// import { Component, useEffect } from 'react';
import { Component } from 'react';
import { DataGrid, GridRowsProp, GridColDef } from '@material-ui/data-grid';
// import { TextField } from '@material-ui/core';
// import DeleteIcon from '@material-ui/icons/Delete';
// import GridRenderCell from '../gridRenderCell/gridRenderCell';
// import Switcher from '../switcher/switcher';

import ButtonDelete from '../buttonDelete/buttonDelete';
import ButtonEdit from '../buttonEdit/buttonEdit';
import AddMaskDialog from '../addMaskDialog/addMaskDialog';
import ReactApiService from '../../services/reactApiService';
// import AppConfig from '../../services/appConfig';
import './maskTable.css';

export default class MaskTable extends Component {
		
  constructor(props) {
    super(props);

		this.dataService = new ReactApiService();
		this.config = props.config;
		this.textFieldClass = 'wpglobus-to-mask-field';
		this.maskChanged = false;
		this.isPostAction = false;
	
		this.state = {
      error: null,
      isLoaded: false,
      tableItems: this.rows,
      tableColumns: this.columns,
    };
	
  }

	tableClassWrapper = 'App-mask-table';
	rowClassWrapper = 'App-mask-table--row';
	maskCellWrapper = 'mask-sell-wrapper';
	editableCellWrapper = 'editable-cell-wrapper';
	actionsCellWrapper = 'actions-cell-wrapper';
	
	getRowClassWrapper = (params) => {
		return this.rowClassWrapper+' '+this.rowClassWrapper+'-'+params.id
	}
	
	onChange = (event) => {
		this.maskChanged = true;
	}
	
	onBlur = (event) => {

		this.isPostAction = true;
		const wrappers = document.getElementsByClassName(this.maskCellWrapper);

		let masks = [];
		for (var i = 0; i < wrappers.length; i++) {
			if ( wrappers[i].textContent !== '' ) {
				masks.push( wrappers[i].textContent );
			}
		}
		
		this.dataService.post({endpoint:'updateMasks',body:{masks:masks,action:'updateMasks'}})
		.then( 
			(response) => {
				this.maskChanged = false;
				this.isPostAction = false;
			}
		)
	}
	
	renderEditableCell = (params) => {
		return params.row.editable === false ? ' ' : 'yes';
	}
	
	isCellEditable = (params) => {
		return params.row.editable;
	}
	
	renderActionsCell = (params) => {
		return (
			<div className={'cell-actions'}>
				<ButtonEdit params={params} rowClassWrapper={this.rowClassWrapper} editable={params.row.editable} />
				<ButtonDelete params={params} rowClassWrapper={this.rowClassWrapper} />
			</div>	
		)
	}
	
	handleCellEditCommit = (params,event,details) => {
		// console.log(params);
		// console.log(event.target.parentNode);
		// console.log(details);
		setTimeout(() => {
			this.onBlur();
		},500);
	}
	
	valueParser = (value, params) => {
		return value;
	}
	
  rows: GridRowsProp = [];	

  columns: GridColDef[] = [
		{ field: 'ID',
			headerName: 'ID',
			width:100 
		},
		{ field: 'mask', 
			headerName: 'Mask to exclude option from list ', 
			width:400, 
			editable: true, 
			valueParser:this.valueParser, 
			cellClassName:this.maskCellWrapper 
		},
		{ field: 'editable', 
			headerName: 'editable mask', 
			headerAlign:'center', 			
			width:200, 
			editable: false, 
			renderCell:this.renderEditableCell, 
			align:'center', 
			cellClassName:this.editableCellWrapper 
		},
		{ field: 'actions', 
			headerName: 'Actions', 
			headerAlign:'center', 
			width:200, 
			renderCell:this.renderActionsCell, 
			align:'center', 
			cellClassName:this.actionsCellWrapper, 
			sortable:false, 
			filterable:false, 
			hideSortIcons:true 
		}
  ];
 
  componentDidMount() {
		this.getData();
  } 
	
  componentWillUnmount() {}
	
	getData() {
		// console.log(this.props.endpoint);
		this.dataService.get(this.props.endpoint)
		.then( 
			(response) => {
				// console.log(' MaskTable response ::', response );
				this.setState({
					isLoaded: true,
					tableItems: response.data.map( item => {
						return {
							id: parseInt(item.id),
							ID: parseInt(item.id),
							mask: item.mask,
							editable: item.editable,
						}
					}) 
				});	
			},
			// Note: it's important to handle errors here
			// instead of a catch() block so that we don't swallow
			// exceptions from actual bugs in components.
			(error) => {
				this.setState({
					isLoaded: true,
					error
				});
			}
		).then(() => {
			return;
		})		
	}
	
	onAfterSave() {
		this.setState({
			isLoaded: false
		});			
		this.getData();
  }
  
	render() {
    
		const { error, isLoaded, tableItems, tableColumns } = this.state;

    if (error) {
      return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      return <div className="App-table-preload">Loading...</div>;
    } else {
			if ( tableItems.length === 0 ) {
				return ( <div style={{ height: 200, width: '100%' }}>No items found.</div> );
			} else {
				return (
					<div className={this.tableClassWrapper}>
						<DataGrid 
							rowHeight={32} 
							pageSize={99} 
							rowsPerPageOptions={[99]} 
							rows={tableItems} 
							columns={tableColumns} 
							getRowClassName={ (params)=>{return this.getRowClassWrapper(params)} } 
							isCellEditable={ (params)=>{return this.isCellEditable(params)} }
							onCellEditCommit={this.handleCellEditCommit}
							rowCount={tableItems.length}
						/>
						<AddMaskDialog afterSave = {this.onAfterSave.bind(this)} />
					</div>
				);
			}
    }
  }
}